import { TextField, type TextFieldProps } from '@mui/material'
import {
  type ChangeEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useSearch } from '@/features/search/hooks/useSearch'
import { useAppSelector } from '@/redux/hooks'

type Props = {
  charLimit?: number
}
export const SearchTextField = (props: Props) => {
  const { charLimit = 40 } = props
  const ref = useRef(null)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const { selectors, updateNext } = useSearch()

  const { searchText } = useAppSelector(selectors.selectNextSearchParameters)

  const [text, setText] = useState(searchText)
  const [errors, setErrors] = useState<string[]>([])
  const isValid = errors.length === 0

  const handleChange: TextFieldProps['onChange'] = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setText(event.target.value)

      if (timeoutRef.current) clearTimeout(timeoutRef.current)

      timeoutRef.current = setTimeout(() => {
        updateNext({ searchText: event.target.value })
        timeoutRef.current = null
      }, 200)
    },
    [updateNext],
  )

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [])

  const validate = () => {
    const newErrors = []
    if (text.length > charLimit) {
      newErrors.push(`Limit of ${charLimit} characters`)
    }
    setErrors(newErrors)
  }

  useEffect(validate, [text, charLimit])

  //Update local state if app state changes
  useEffect(() => {
    setText(searchText)
  }, [searchText])

  return (
    <TextField
      ref={ref}
      name="searchText"
      error={!isValid}
      fullWidth
      value={text}
      onChange={handleChange}
      placeholder="Search by Media Number or Text"
      helperText={errors[0]}
      slotProps={{
        input: {
          sx: {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          },
        },
      }}
    />
  )
}
